import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KycHypervergeRoutingModule } from './kyc-hyperverge-routing.module';
import { KycHypervergeComponent } from './kyc-hyperverge.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AuthGuard } from '../login/auth.guard';


@NgModule({
  declarations: [KycHypervergeComponent],
  imports: [
    CommonModule,
    KycHypervergeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
  ],
  providers: [AuthGuard]
})
export class KycHypervergeModule { }
